import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-info-circle',
  template: `
    <div class="circle-container" [ngClass]="{'failure': failure}">
      <span class="circle">{{index}}</span>
    </div>
  `,
  styleUrls: ['./info-circle.component.scss']
})
export class InfoCircleComponent implements OnInit {
  @Input() failure: boolean = false;
  @Input() index: number;

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/atoms/info-circle/info-circle.component.ts